export default "__VITE_ASSET__B9KwdxS7__"